var map = {
	"./MultipleCurrency/translations/en.json": 36654,
	"./PriceBreakdown/translations/en.json": 62021,
	"./transactionProcesses/defaultPurchase/translations/en.json": 9065,
	"./transactionProcesses/sellPurchase/translations/en.json": 91616,
	"./transactionProcesses/translations/en.json": 78648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34880;